import uiReducer from "./slices/ui.slice";
import { configureStore } from "@reduxjs/toolkit";
import meetingReducer from "./slices/meeting.slice";
import preJoinReducer from "./slices/preJoin.slice";
import connectionReducer from "./slices/connection.slice";

// Redux Store Configuration
const store = configureStore({
  reducer: {
    connection: connectionReducer,
    meeting: meetingReducer,
    ui: uiReducer,
    preJoin: preJoinReducer
  },
  // Enable Redux DevTools in development
  devTools: process.env.NODE_ENV !== "production"
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
